import { Direction, Speed } from '../../entities';

export class ScrollRecord {

  private readonly speedRatio = 1; // min px scroll distance / ms ratio to show navbar

  private y = scrollY;
  private updatedAt = new Date;

  get direction(): Direction {
    return this.distance < 0
      ? Direction.Down
      : Direction.Up;
  }

  /**
   * Returns scrolled distance in px since the last update
   */
  get distance(): number {
    return this.y - scrollY;
  }

  /**
   * Returns passed time in milliseconds since the last update
   */
  get passedTime(): number {
    return (new Date()).getTime() - this.updatedAt.getTime();
  }

  get speed(): Speed {
    return this.distance / this.passedTime > this.speedRatio
      ? Speed.Fast
      : Speed.Slow;
  }

  update() {
    this.y = scrollY;
    this.updatedAt = new Date;
  }

}
